import { ISODateTime } from './date'
import { ScopeId } from './scope'

export interface MappingExport {
  id?: string
  scopeId: ScopeId
  tagId: string
  status?: 'CREATED' | 'FAILED' | 'INPROGRESS'
  createdAt?: ISODateTime
  expiringAt?: Date
}

export const MAPPING_DOWNLOAD_TYPES = ['adunits', 'bidders-mapping', 'all'] as const
export type MappingDownloadType = (typeof MAPPING_DOWNLOAD_TYPES)[number]

//----------------------------------------
// File names/paths/ids
//----------------------------------------

// Common
export const mappingExportsS3FilePath = (tagId: string, createdAt: ISODateTime): string => `outputs/tagId=${tagId}/date=${createdAt}`

// Ad units file
export const AD_UNITS_FILE_ID = 'mapping-export_adunits'
export const adUnitsS3FilePath = (tagId: string, createdAt: ISODateTime): string => {
  return `${mappingExportsS3FilePath(tagId, createdAt)}/${AD_UNITS_FILE_ID}.csv`
}
export const adUnitsDownloadFileId = (siteName: string): string => `${siteName}_${AD_UNITS_FILE_ID}`

// Bidder mapping file
export const BIDDER_MAPPING_FILE_ID = 'mapping-export_bidders'
export const bidderMappingS3FilePath = (tagId: string, createdAt: ISODateTime, bidderCode: string): string => {
  return `${mappingExportsS3FilePath(tagId, createdAt)}/${BIDDER_MAPPING_FILE_ID}_${bidderCode}.csv`
}
export const biddersMappingDownloadFileId = (siteName: string): string => `${siteName}_${BIDDER_MAPPING_FILE_ID}`

// All mapping file
export const ALL_MAPPING_FILE_ID = 'mapping-export_all'
export const allMappingFileId = (siteName: string): string => `${siteName}_${ALL_MAPPING_FILE_ID}`
